export default {
  'rdc.default.table.operation': '操作',
  'rdc.default.modal.add': '新增',
  'rdc.default.modal.edit': '编辑',
  'rdc.default.modal.detail': '详情',
  'rdc.default.modal.close': '关闭',
  'rdc.default.operation.success': '操作成功',
  'rdc.default.operation.error': '操作失败',
  'rdc.default.button.submit': '提交',
  'rdc.default.button.import': '导入',
  'rdc.default.button.export': '导出',
  'rdc.default.button.delete': '删除',
  'rdc.default.button.yes': '是',
  'rdc.default.button.no': '否',
  'rdc.default.button.notify': '提醒',
  'rdc.default.button.generate': '生成',
  'rdc.default.button.upload': '上传',
  'rdc.default.button.import_receive_date': '导入签收日期',
  'rdc.default.button.import_delivery': '导入运单',
  'rdc.default.button.download': '点击下载',
  'rdc.default.notify.confirm': '确认发送邮件提醒货代吗',
  'rdc.default.delete.confirm': '确认要删除吗',
  'rdc.default.please.input': '请输入',
  'rdc.default.import.title': '数据导入',
  'rdc.default.import.template.tips': '模板下载：',
  'rdc.default.import.template.download': '下载导入模板.xlsx',
  'rdc.default.import.accept': '支持格式：',
  'rdc.default.import.upload': '点击上传文件',
  'rdc.default.import.upload_receive': '上传签收单文件',
  'rdc.default.import.loading': '导入中...',
  'rdc.default.import.waiting': '等待中',
  'rdc.default.import.uploading': '上传中',
  'rdc.default.import.processing': '处理中',
  'rdc.default.import.done': '已完成',
  'rdc.default.import.error': '错误',
  'rdc.default.import.fileList': '上传文件列表',
  'rdc.default.export.selected_rows': '请选择至少一条数据进行导出',

  'rdc.system.status.enable': '启用',
  'rdc.system.status.disable': '禁用',
  'rdc.system.status.yes': '是',
  'rdc.system.status.no': '否',

  'rdc.login.title': '货代签收系统',
  'rdc.system.user.account': '账号',
  'rdc.system.user.email': '邮箱',
  'rdc.system.user.role': '角色',
  'rdc.system.user.status': '状态',
  'rdc.system.user.org': '组织',

  'rdc.system.role.name': '角色名称',
  'rdc.system.role.code': '角色编码',
  'rdc.system.role.create_at': '创建时间',
  'rdc.system.role.update_at': '更新时间',
  'rdc.system.role.auth': '权限',

  'rdc.system.log.log_type': '日志类型',
  'rdc.system.log.log_level': '日志等级',
  'rdc.system.log.user_name': '操作人',
  'rdc.system.log.operation_time': '操作时间',
  'rdc.system.log.module': '模块',
  'rdc.system.log.action_type': '操作类型',
  'rdc.system.log.object_name': '对象名称',
  'rdc.system.log.description': '描述',
  'rdc.system.log.result': '操作结果',
  'rdc.system.log.additional_data': '附加数据',
  'rdc.system.log.customer_code': '客户编号',
  'rdc.system.log.ob_no': '运单号',
  'rdc.system.log.dispatch_time': '出库时间',
  'rdc.system.log.type.operation': '操作',
  'rdc.system.log.type.login': '登录',
  'rdc.system.log.type.manual': '手动',
  'rdc.system.log.type.system': '系统',
  'rdc.system.log.level.info': '信息',
  'rdc.system.log.level.error': '逻辑异常',
  'rdc.system.log.level.fatal': '系统异常',

  'rdc.system.dict.type': '字典Code',
  'rdc.system.dict.name': '字典名称',
  'rdc.system.dict.status': '状态',
  'rdc.system.dict.remark': '备注',
  'rdc.system.dict.key': '明细Key',
  'rdc.system.dict.value': '明细值',
  'rdc.system.dict.sort': '排序',
  'rdc.system.dict.extend': '扩展属性',

  'rdc.report.title': '统计',
  'rdc.report.period': '统计周期：',

  'sales.name': '销售名称',
  'sales.mobile': '销售电话',
  'sales.code': '工号',
  'sales.company': '所属公司',
  'sales.bind_time': '绑定时间',
  'sales.customer_count': '客户数',
  'sales.visit_count': '拜访数',

  'customer.name': '客户名称',
  'customer.code': '客户代码',
  'customer.province': '省份',
  'customer.city': '城市',
  'customer.district': '区县',
  'customer.address': '详细地址',
  'customer.industry': '行业',
  'customer.category': '客户类别',
  'customer.sales': '所属销售',

  'visit.customer': '客户名称',
  'visit.sales': '所属销售',
  'visit.contact': '联系人',
  'visit.contact_mobile': '联系电话',
  'visit.visit_date': '拜访日期',
  'visit.division': 'Division',
  'visit.category': '拜访类型',
  'visit.objective': '目的',
  'visit.visit_plan': '拜访计划',
  'visit.visit_result': '拜访结果',
  'visit.meeting_time': '会谈时间',
  'visit.journey_time': '路途时间',
  'visit.content': '具体内容',
  'visit.location': '定位',
  'visit.image': '图片',
  'visit.video': '视频',
  'visit.compressor_model': '压缩机型号',
  'visit.compressor_brand': '压缩机品牌',
  'visit.compressor_qty': '压缩机数量',
  'visit.equipment_model': '附属设备型号',
  'visit.equipment_brand': '附属设备品牌',
  'visit.equipment_qty': '附属设备数量',
  'visit.air_running_time': '运行时间',
  'visit.air_loading_time': '加载时间',
  'visit.air_evaluate': '客户评价',
  'visit.air_purchase_time': '采购时间',
  'visit.compressor': '压缩机产品',
  'visit.quality_air': '附属设备',
  'visit.purchase_date': '设备采购时间',
  'visit.qty_completed_rate': '整机台数完成率',
  'visit.amount_completed_rate': '服务金额完成率',
  'visit.project_qty': '整机在手项目台数',
  'visit.project_amount': '服务在手项目金额',
  'visit.is_matching': '是否配套',
  'visit.matching_brand': '配套品牌',
  'visit.matching_qty': '配套规模',
  'visit.brand_chance': 'LIUTECH品牌机会',
  'visit.industry': '主要针对行业',
  'visit.compete_brand': '主要竞争品牌',
  'visit.past_qty': '过去三年平均空压机年销台数',
  'visit.is_push_crm': '是否推送至CRM',
  'visit.crm_id': 'CRMID',
}
